<template>
    <div class="font-14" style="height: 480px">
        <loader object="#df3e46" v-show="progressProjeto || carregandoExterno" color1="#0db9d3" color2="#fff01f" size="6" speed="2.4" bg="#C0C0C0" objectbg="#0d0c0d" opacity="50" name="circular"></loader>
        <div class="card">
            <div class="p-2" style="height: 455px;">
                <div class="row">
                    <div class="col-9">
                        <div class="col text-bold-6">
                            <span style="font-size: 14px" class="ml--2">Projeto</span> - <span style="font-size: 14px" :class="'situacao-'+ projeto.situacao">{{projeto.codigo}}</span>
                        </div>
                        <div class="col">
                            <div class="text-bold-6 ml--2" style="height: 50px;">
                                <el-tooltip :content="projeto.titulo" placement="top">
                                    <span style="font-size: 18px" :class="'situacao-'+ projeto.situacao">{{ (projeto.titulo || '').trim().substring(0, 180) }}{{ (projeto.titulo || '').length > 180 ? "..." : "" }}</span>
                                </el-tooltip>
                            </div>
                        </div>
                    </div>
                    <div class="col-3 mt-1 text-bold-6">
                        <div>
                            Situação
                        </div>
                        <div :class="'situacao-'+ projeto.situacao">
                            {{projeto.situacaoDescricao}}
                        </div>
                    </div>
                </div>

                <ul class="nav nav-tabs mt-2 bg-light text-bold-6" id="tabProjeto" role="tablist">
                    <li class="nav-item">
                        <a class="nav-link active" id="tab-projeto-link" data-toggle="tab" href="#projeto-dados" role="tab" 
                            aria-controls="projeto-dados" aria-selected="true">
                            Projeto
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" id="tab-projeto-atividades-link" data-toggle="tab" href="#projeto-atividades" role="tab" 
                                aria-controls="projeto-atividades" aria-selected="false">
                            Atividades
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" id="tab-projeto-timeline-link" data-toggle="tab" href="#projeto-timeline" role="tab" 
                                aria-controls="projeto-timeline" aria-selected="false">
                            Timeline
                        </a>
                    </li>
                </ul>
                <div class="tab-content mt-3" style="height: 325px;" id="tabProjetoContent">

                    <!-- Projeto -->
                    <div class="container mt-2 tab-pane fade show active" id="projeto-dados" role="tabpanel" aria-labelledby="tab-projeto-link">

                         <div class="row menuOpcao mb-2">
                            <div class="col-12 text-right">
                                <el-tooltip content="Novo Projeto" placement="top">
                                    <i 
                                        @click="incluirProjeto()"
                                        class="fas fa-calendar-plus icones iconeReagendar"></i>
                                </el-tooltip>
                                <el-tooltip 
                                        v-if="situacaoNaoCACOProjeto(projeto)"
                                        content="Reagendar Projeto" placement="top">
                                    <i 
                                        @click="modalReagendarProjeto()"
                                        class="fas fa-calendar-alt ml-3 icones iconeReagendar"></i>
                                </el-tooltip>
                                
                                <el-tooltip 
                                        v-if="situacaoREJEITADOProjeto(projeto)"
                                        content="Alterar Projeto" placement="top">
                                    <i 
                                        @click="alterarProjeto(projeto)"
                                        class="fas fa-edit ml-3 icones iconeAlterar"></i>
                                </el-tooltip>
                                <el-tooltip 
                                    v-if="situacaoNaoCACOProjeto(projeto)"
                                    content="Cancelar Projeto" placement="top">
                                    <i 
                                        @click="modalCancelarProjeto(projeto)"
                                        class="far fa-calendar-times ml-3 icones iconeCancelar"></i>
                                </el-tooltip>
                                <el-tooltip 
                                    v-if="!situacaoProjeto('CANCELADO') && !carregandoAtividades"
                                    content="Concluir Projeto" placement="top">
                                    <i 
                                        @click="concluirProjeto(projeto)"
                                        class="fas fa-calendar-check ml-3 icones iconeConcluir"></i>
                                </el-tooltip>
                                <el-tooltip v-if="exibirOpcaoExcluirProjeto()"
                                    content="Excluir Projeto" placement="top">
                                        <i @click="excluirProjeto(projeto)"
                                            class="fa fa-trash ml-3 icones iconeCancelar"></i>
                                </el-tooltip>
                            </div>
                        </div>                      
                        <div class="row mt-3">
                            <div :class="(situacaoProjeto('EMANDAMENTO')) ? 'col-4' : 'col-6'">
                                <div class="text-bold-6">
                                    Data Início e Fim
                                </div>
                                <div v-if="!modals.modalReagendarProjeto"
                                    :class="(projeto.reagendado) ? 'font-reagenda' : ''"> 
                                    {{projeto.dataInicio}} até {{projeto.dataFim}}
                                    <el-tooltip 
                                            class="ml-2"
                                            v-if="situacaoNaoCACOProjeto(projeto)"
                                            content="Reagendar Projeto" placement="top">
                                        <i 
                                            @click="modalReagendarProjeto()"
                                            class="fas fa-calendar-alt icones iconeReagendar"></i>
                                    </el-tooltip>
                                </div>
                                <div class="row" v-if="modals.modalReagendarProjeto">
                                    <div class="col-5">
                                        <flat-picker
                                            value=""
                                            tabindex="3"
                                            id="dataInicio"
                                            class="form-control datepicker mb-2"
                                            placeholder="Data Início"
                                            v-model="projetoReagenda.dataInicio"
                                            :config="{
                                                allowInput: true,
                                                dateFormat: 'd/m/Y',
                                                altFormat: 'M j, Y',
                                            }"/>
                                    </div>
                                    <div class="col-5">
                                        <flat-picker
                                            value=""
                                            tabindex="3"
                                            id="dataFim"
                                            class="form-control datepicker mb-2 ml-n2"
                                            placeholder="Data Fim"
                                            v-model="projetoReagenda.dataFim"
                                            :config="{
                                                allowInput: true,
                                                minDate: projetoReagenda.dataInicio,
                                                dateFormat: 'd/m/Y',
                                                altFormat: 'M j, Y',
                                            }"/>
                                    </div>
                                    <div class="col-2 mt-2">
                                        <el-tooltip content="Reagendar Projeto" placement="top">
                                            <i 
                                                @click="reagendarProjeto()"
                                                class="fas fa-check-circle ml-n2 text-success icones"></i>
                                        </el-tooltip>
                                        <el-tooltip content="Desistir" placement="top">
                                            <i 
                                                @click="fecharModalReagendarProjeto()"
                                                class="fas fa-times ml-2 text-danger icones"></i>
                                        </el-tooltip>
                                    </div>
                                </div>
                            </div>
                            <div :class="(situacaoProjeto('ATRASADO')) ? 'col-3' : 'col-2'">
                                <div class="text-bold-6">
                                    Investimento
                                </div>
                                <div>
                                    {{investimentoProjetoFmt}}
                                </div>
                            </div>
                            <div class="col-2" v-if="situacaoProjeto('ATRASADO')">
                                <div class="text-bold-6">
                                    Atrasado
                                </div>
                                <div class="situacao-ATRASADO">
                                    {{projeto.atraso}}
                                </div>                             
                            </div>
                            <div class="col-2" v-if="situacaoProjeto('NAOINICIADO')">
                                <div class="text-bold-6">
                                    Início
                                </div>
                                <div>
                                    {{projeto.inicio}}
                                </div>                             
                            </div>
                            <div class="col-3" v-if="situacaoProjeto('EMANDAMENTO')">
                                <div class="text-bold-6">
                                    Progresso
                                </div>
                                <div>
                                    <div class="progress mt-1">
                                        <div class="progress-bar" role="progressbar" 
                                            :style="'font-size: 11px; width: '+ projeto.progresso +'%;'"
                                            :class="'progresso-'+ projeto.situacao">
                                            {{projeto.progresso}}%
                                        </div>  
                                    </div>                                
                                </div>
                            </div>
                            <div class="col-2" v-if="situacaoProjeto('EMANDAMENTO')">
                                <div class="text-bold-6">
                                    Término
                                </div>
                                <div>
                                    {{projeto.termino}}
                                </div>
                            </div>
                            <div class="col-2" v-if="situacaoProjeto('CONCLUIDO')">
                                <div class="text-bold-6">
                                    Concluído
                                </div>
                                <div class="situacao-CONCLUIDO">
                                    {{projeto.concluido}}
                                </div>
                            </div>
                            <div class="col-2" v-if="situacaoProjeto('CANCELADO')">
                                <div class="text-bold-6">
                                    Cancelado
                                </div>
                                <div class="situacao-CANCELADO">
                                    {{projeto.concluido}}
                                </div>
                            </div>
                        </div>
                        <div class="row mt-1">
                            <div class="col-6">
                                <div class="text-bold-6">
                                    Criado por
                                </div>
                                <div class="row">
                                    <div class="col-1" v-if="projeto.criador && projeto.criador.avatar">
                                        <img :src="projeto.criador.avatar" :title="projeto.criador.nome" width="27" class="rounded-circle ml-2 mr-2">
                                    </div>
                                    <div class="col ml-3 mt-1">
                                        {{ (projeto.criador && projeto.criador.apelido) ? projeto.criador.apelido : '-' }}
                                    </div>
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="text-bold-6">
                                    Classificação
                                </div>
                                <div>
                                    {{projeto.classificacaoDescricao}}
                                </div>
                            </div>
                            <div class="col-2">
                                <div class="text-bold-6">
                                    Relevância
                                </div>
                                <div>
                                    <i :class="getIconClass(projeto.relevanciaCriador)" :title="'Relevância '+ projeto.relevanciaDescricao"></i> {{projeto.relevanciaDescricao}}
                                </div>
                            </div>
                        </div>

                        <div class="row mt-2">
                            <div class="col-6">
                                <div class="text-bold-6">
                                    Responsável(is) 
                                    <el-tooltip content="Adicionar um responsável" 
                                        v-if="perfilCoordenador && situacaoAbertoProjeto(projeto)"
                                        placement="top">
                                        <span @click="abrirModalAdicionarResponsavel()" class="clickable" style="color: #006200; margin-left: 10px;"><i class="fas fa-user-plus"></i></span>
                                    </el-tooltip>
                                </div>
                                <div class="listaResponsavelProjeto">
                                    <div v-for="resp in projeto.listaResponsavel" :key="resp.idusuario">
                                        <!-- <img :src="resp.avatar" :title="resp.nome" width="27" 
                                            class="rounded-circle ml-1 mr-2 mt-1"> {{resp.apelido}} -->
                                        <div class="row">
                                            <div class="col-1">
                                                <img :src="resp.avatar" :title="resp.nome" width="27" 
                                                    class="rounded-circle ml-2 mr-2">
                                            </div>
                                            <div class="col ml-3 mt-1">
                                                {{resp.apelido}} <span v-if="resp.pendente"><i>(pendente)</i></span>
                                                <el-tooltip :content="'Remover '+ resp.apelido" 
                                                    v-if="resp.pendente != true && perfilCoordenador && situacaoAbertoProjeto(projeto)"
                                                    placement="top">
                                                    <span @click="removerResponsavel(resp)" class="clickable" style="color: #b90000; margin-left: 10px;"><i class="fas fa-user-times"></i></span>
                                                </el-tooltip>
                                            </div>
                                        </div>                                            
                                    </div>
                                    <div v-for="resp in projeto.listaResponsavelPendente" :key="'pendente-'+ resp.idusuario">
                                        <div class="row">
                                            <div class="col-1">
                                                <img :src="resp.avatar" :title="resp.nome" width="27"
                                                    class="rounded-circle ml-2 mr-2">
                                            </div>
                                            <div class="col ml-3 mt-1">
                                                {{resp.apelido}} <i>(pendente)</i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="text-bold-6">
                                    Grupo de Trabalho
                                </div>
                                <div class="listaResponsavelProjeto">
                                    <div v-for="gt in projeto.listaGrupoTrabalho" :key="gt.idgt">
                                        - {{gt.nome}}<br/>
                                    </div>
                                </div>
                            </div>
                        </div>                         

                    </div>

                    <!-- Atividades -->
                    <div class="container mt-2 tab-pane fade show" id="projeto-atividades" role="tabpanel" aria-labelledby="tab-projeto-atividades-link">
                        
                        <div class="row mt-1">
                            <div class="col"> 
                                <div class="row text-center">
                                    <div class="col-1 p-0">
                                        <el-tooltip content="Nova Atividade" 
                                            v-if="!situacaoVACACOREProjeto(projeto)"
                                            placement="top">
                                            <i 
                                                @click="incluirAtividade()"
                                                class="far fa-calendar-plus ml-3 icones iconeReagendar"></i>
                                        </el-tooltip>
                                    </div>
                                    <div class="col p-0 mr-1 filtroTarefa" 
                                        :class="'filtroNI'+ sitFiltroAtividade.NI"
                                        @click="filtraAtividadeNI">
                                        Não Iniciada
                                    </div>
                                    <div class="col p-0 mr-1 filtroTarefa" 
                                        :class="'filtroEA'+ sitFiltroAtividade.EA"
                                        @click="filtraAtividadeEA">
                                        Em Andamento
                                    </div>
                                    <div class="col p-0 mr-1 filtroTarefa" 
                                        :class="'filtroAT'+ sitFiltroAtividade.AT"
                                        @click="filtraAtividadeAT">
                                        Atrasada
                                    </div>
                                    <div class="col p-0 mr-1 filtroTarefa" 
                                        :class="'filtroCO'+ sitFiltroAtividade.CO"
                                        @click="filtraAtividadeCO">
                                        Concluída
                                    </div>
                                    <div class="col p-0 filtroTarefa" 
                                        :class="'filtroCA'+ sitFiltroAtividade.CA"
                                        @click="filtraAtividadeCA">
                                        Cancelada
                                    </div>
                                    <div class="col-1 p-0">

                                    </div>
                                </div>
                                <div class="listaAtividade text-justify">

                                    <div style="color: #8c9db3; text-align: center;" v-if="carregandoAtividades">
                                        <div style="margin-top: 60px;">
                                            <span class="spinner-border spinner-border-sm mr-2" role="status">
                                                <span class="sr-only">Loading...</span>
                                            </span>Carregando Atividades...
                                        </div>
                                    </div>
                                    <div class="mt-2 text-center" v-if="!carregandoAtividades && listaAtividade.length == 0">
                                        Nenhuma atividade encontrada
                                    </div>
						            
                                    <div id="accordionAtividades">
                                        <div class="atividadeIndividual" v-for="(atividade, index) in listaAtividade" 
                                                :key="atividade.idatividade">

                                            <div class="row menuOpcao text-bold-6 clickable p-2"
                                                    style="width: 100%;"
                                                    :id="`heading` + index"
                                                    data-toggle="collapse"
                                                    :data-target="`#collapse` + index"
                                                    aria-expanded="true"
                                                    :aria-controls="`collapse` + index">
                                                <div class="col-8 text-left" :class="'situacao-'+ atividade.situacao">
                                                    <img :src="atividade.criador.avatar" :title="atividade.criador.nome" width="27" class="rounded-circle">
                                                    {{ atividade.codigoNome }} <i @click="abrirModalAtividade(atividade)" class="fas fa-link ml-2 iconeReagendar"></i>
                                                </div>
                                                <div class="col-2 text-right" :class="'situacao-'+ atividade.situacao">
                                                    {{ atividade.situacaoDescricao }} <span v-if="situacaoAtividade(atividade, 'ATRASADA')">({{atividade.atrasada}})</span>
                                                </div>
                                                <div class="col-2 text-right">
                                                    <el-tooltip 
                                                            v-if="situacaoNaoCACOAtividade(atividade)"
                                                            content="Reagendar Atividade" placement="top">
                                                        <i 
                                                            @click="modalReagendarAtividade(index, atividade)"
                                                            class="fas fa-calendar-alt icones iconeReagendar"></i>
                                                    </el-tooltip>
                                                    <el-tooltip 
                                                            v-if="situacaoNaoCACOAtividade(atividade)"
                                                            content="Alterar Atividade" placement="top">
                                                        <i 
                                                            @click="alterarAtividade(atividade)"
                                                            class="fas fa-edit ml-3 icones iconeAlterar"></i>
                                                    </el-tooltip>
                                                    <el-tooltip content="Histórico da Atividade " placement="top">
                                                        <i 
                                                            @click="modalHistoricoAtividade(atividade)"
                                                            class="far fa-eye ml-3 icones iconeReagendar"></i>
                                                    </el-tooltip>
                                                    <el-tooltip 
                                                        v-if="situacaoNaoCACOAtividade(atividade)"
                                                        content="Cancelar Atividade" placement="top">
                                                        <i 
                                                            @click="modalCancelarAtividade(atividade)"
                                                            class="far fa-calendar-times ml-3 icones iconeCancelar"></i>
                                                    </el-tooltip>
                                                    <el-tooltip 
                                                        v-if="situacaoNaoCACOAtividade(atividade)"
                                                        content="Concluir Atividade" placement="top">
                                                        <i 
                                                            @click="concluirAtividade(atividade)"
                                                            class="fas fa-calendar-check ml-3 icones iconeConcluir"></i>
                                                    </el-tooltip>
                                                </div>
                                                <div class="col-10" style="height: 10px;" v-if="situacaoAtividade(atividade, 'EMANDAMENTO')">
                                                    <div class="progress mt-1" style="height: 2px;">
                                                        <div class="progress-bar" role="progressbar" 
                                                            :style="'width: '+ atividade.progresso +'%;'">
                                                        </div>     
                                                    </div>  
                                                </div>
                                            </div>
                                            <div :id="`collapse` + index" class="collapse mt-3" :aria-labelledby="`heading` + index" data-parent="#accordionAtividades">
                                                <!--
                                                <div class="row mt-2 text-bold-6">
                                                    <div class="col-9">
                                                        <span :class="'titulo-'+ atividade.situacao"
                                                                class="clickable" @click="abrirModalAtividade(atividade)">
                                                            {{ atividade.codigoNome }}<i class="fas fa-link ml-3"></i>
                                                        </span>
                                                    </div>
                                                    <div class="col-3">
                                                        <div class="text-bold-6">
                                                            Situação: 
                                                            <span :class="'situacao-'+ atividade.situacao">
                                                                {{ atividade.situacaoDescricao }}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                -->
                                                <div class="row mt-2">
                                                    <div class="col-5">
                                                        <div class="text-bold-6">
                                                            Data Início e Fim
                                                        </div>
                                                        <div v-if="!modals.modalReagendarAtividade[index]"
                                                            :class="(atividade.reagendada) ? 'font-reagenda' : ''"> 
                                                            {{atividade.dataInicio}} até {{atividade.dataFim}}
                                                            <el-tooltip 
                                                                    class="ml-2"
                                                                    v-if="situacaoNaoCACOAtividade(atividade)"
                                                                    content="Reagendar Atividade" placement="top">
                                                                <i 
                                                                    @click="modalReagendarAtividade(index, atividade)"
                                                                    class="fas fa-calendar-alt icones iconeReagendar"></i>
                                                            </el-tooltip>
                                                        </div>
                                                        <div class="row" v-if="modals.modalReagendarAtividade[index]">
                                                            <div class="col-5">
                                                                <flat-picker
                                                                    value=""
                                                                    tabindex="3"
                                                                    id="dataInicio"
                                                                    class="form-control datepicker mb-2"
                                                                    placeholder="Data Início"
                                                                    v-model="atividadeReagenda.dataInicio"
                                                                    :config="{
                                                                        allowInput: true,
                                                                        minDate: new Date(projeto.dataInicioYMD),
                                                                        maxDate: new Date(projeto.dataFimYMD),
                                                                        dateFormat: 'd/m/Y',
                                                                        altFormat: 'M j, Y',
                                                                    }"/>
                                                            </div>
                                                            <div class="col-5">
                                                                <flat-picker
                                                                    value=""
                                                                    tabindex="3"
                                                                    id="dataFim"
                                                                    class="form-control datepicker mb-2 ml-n2"
                                                                    placeholder="Data Fim"
                                                                    v-model="atividadeReagenda.dataFim"
                                                                    :config="{
                                                                        allowInput: true,
                                                                        minDate: atividadeReagenda.dataInicio,
                                                                        maxDate: new Date(projeto.dataFimYMD),
                                                                        dateFormat: 'd/m/Y',
                                                                        altFormat: 'M j, Y',
                                                                    }"/>
                                                            </div>
                                                            <div class="col-2 mt-2">
                                                                <el-tooltip content="Reagendar Atividade" placement="top">
                                                                    <i 
                                                                        @click="reagendarAtividade(index, atividade)"
                                                                        class="fas fa-check-circle ml-n2 text-success icones"></i>
                                                                </el-tooltip>
                                                                <el-tooltip content="Desistir" placement="top">
                                                                    <i 
                                                                        @click="fecharModalReagendarAtividade(index)"
                                                                        class="fas fa-times ml-2 text-danger icones"></i>
                                                                </el-tooltip>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-4">
                                                        <div class="text-bold-6">
                                                            Investimento {{ (atividade.investimentoNaoEmpenho > 0) ? '/ Não Empenhado' : ''}}
                                                        </div>
                                                        <div>
                                                            {{atividade.investimentoFmt}} {{(atividade.investimentoNaoEmpenho > 0) ? '/ '+ atividade.investimentoNaoEmpenhoFmt : ''}}
                                                        </div>
                                                    </div>
                                                    <div class="col-3" v-if="situacaoAtividade(atividade, 'NAOINICIADA')">
                                                        <div class="text-bold-6">
                                                            Início
                                                        </div>
                                                        <div>
                                                            {{atividade.inicio}}
                                                        </div>                             
                                                    </div>
                                                    <div class="col-3" v-if="situacaoAtividade(atividade, 'ATRASADA')">
                                                        <div class="text-bold-6">
                                                            Atrasada
                                                        </div>
                                                        <div :class="'situacao-'+ atividade.situacao">
                                                            {{atividade.atrasada}}
                                                        </div>
                                                    </div>
                                                    <div class="col-3" v-if="situacaoAtividade(atividade, 'EMANDAMENTO')">
                                                        <div class="text-bold-6">
                                                            Progresso
                                                        </div>
                                                        <div>
                                                            <div class="progress mt-1">
                                                                <div class="progress-bar" role="progressbar" 
                                                                    :style="'font-size: 11px; width: '+ atividade.progresso +'%;'"
                                                                    :class="'progresso-'+ atividade.situacao">
                                                                    {{atividade.progresso}}%
                                                                </div>     
                                                            </div>                                
                                                        </div>
                                                    </div>
                                                    <div v-if="situacaoNaoCACOAtividade(atividade) && atividade.termino!='0'" class="col-2">
                                                        <div class="text-bold-6">
                                                            Término
                                                        </div>
                                                        <div>
                                                            {{atividade.termino}}
                                                        </div>
                                                    </div>
                                                    <div v-if="situacaoAtividade(atividade, 'CONCLUIDA')" class="col-3">
                                                        <div class="text-bold-6">
                                                            Data de conclusão
                                                        </div>
                                                        <div :class="'situacao-'+ atividade.situacao">
                                                            {{atividade.dataConclusao}}
                                                        </div>
                                                    </div>
                                                    <div v-if="situacaoAtividade(atividade, 'CANCELADA')" class="col-3">
                                                        <div class="text-bold-6">
                                                            Data de cancelamento
                                                        </div>
                                                        <div :class="'situacao-'+ atividade.situacao">
                                                            {{atividade.dataConclusao}}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row mt-3">
                                                    <div class="col-5">
                                                        <div class="text-bold-6">
                                                            Responsável(is)
                                                        </div>
                                                        <div class="listaResponsavelProjeto">
                                                            <div v-for="resp in atividade.listaResponsavel" :key="resp.idusuario">
                                                                <div class="row">
                                                                    <div class="col-1">
                                                                        <img :src="resp.avatar" :title="resp.nome" width="27" class="rounded-circle ml-2 mr-2">
                                                                    </div>
                                                                    <div class="col ml-3 mt-1">
                                                                        {{resp.apelido}}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-4">
                                                        <div class="text-bold-6">
                                                            Criado por
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-1">
                                                                <img :src="atividade.criador.avatar" :title="atividade.criador.nome" width="27" class="rounded-circle ml-2 mr-2">
                                                            </div>
                                                            <div class="col ml-3 mt-1">
                                                                {{atividade.criador.apelido}}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-3">
                                                        <div class="text-bold-6">
                                                            Tipo
                                                        </div>
                                                        <div>
                                                            {{atividade.tipoDescricao}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>      
                        </div>
                    </div>

                    <!-- Timeline  -->
                    <div class="container mt-2 tab-pane fade show" id="projeto-timeline" role="tabpanel" aria-labelledby="tab-projeto-timeline-link">
                        <div class="mt-2 text-center" v-if="carregandoTimeline">
                            <span class="spinner-border spinner-border-sm mr-2" role="status">
                                <span class="sr-only">Loading...</span>
                            </span>Carregando timeline...
                        </div>
                        <div class="mt-2 text-center" v-else-if="listaTimeline.length == 0">
                            Nenhum histórico registrado
                        </div>
                        <div class="container-timeline" v-else>
                            <ul class="timeline timeline-header">
                                <li class="timeline-item"
                                    v-for="h in listaTimeline" :key="h.idprojetohistorico">

                                    <div :class="`timeline-badge `+ h.style">
                                    <!-- <div :class="`timeline-badge`"> -->
                                        <i :class="h.icone"></i>
                                        <!-- <i class="far fa-calendar-check"></i>-->
                                    </div>
                                    <div class="timeline-panel">
                                        <div class="timeline-heading">
                                            <h6 class="text-uppercase timeline-title">{{ h.titulo }}</h6>
                                        </div>
                                        <div class="timeline-autor p-0" v-if="h.nome != null">Por: {{ h.nome }}</div>
                                        <div class="timeline-body p-0" v-if="h.descricao != null">{{ h.descricao }}</div>
                                        <div class="timeline-tempoDataHora">{{ h.dataAlteracao }} - {{ h.tempoDataHora }}</div>
                                    </div> 
                                </li>
                            </ul>				
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <modal :show.sync="modals.modalCancelarProjeto">
            <loader object="#df3e46" v-show="progressProjetoCancelar" color1="#0db9d3" color2="#fff01f" size="6" speed="2.4" bg="#C0C0C0" objectbg="#0d0c0d" opacity="50" name="circular"></loader>
            <form class="ml-3 mt-3 mr-3 mb-3">
                <h4 class="text-center">Cancelar Projeto</h4>
                <div class="row">

                    <div class="col">
                        <label for="inputTitulo">
                            Justificativa do cancelamento
                            <el-tooltip content="Campo obrigatório" placement="top">
                                <i style="font-size: 12px" class="fas fa-exclamation-circle text-info ml-1"></i>
                            </el-tooltip>
                        </label>
                        <div class="input-group">
                            <div class="input-group-prepend mb-2">
                                <span class="input-group-text"><i class="fas fa-align-left"></i></span>
                            </div>
                            <textarea rows="2" 
                                v-model="projetoCancelar.justificativa"
                                class="form-control mb-2"
                                maxlength="200"
                                placeholder="Preencha a justificativa"></textarea>
                        </div>
                    </div>
                </div>
                <br class="clear" />
                <div class="row">
                    <div class="col text-center mt-3">
                        <button type="button" 
                                @click="fecharModalCancelarProjeto()"
                                class="btn btn-danger mr-3">
                            Desistir
                        </button>
                        <button type="button" 
                                @click="cancelarProjeto()"
                                class="btn btn-success ml-3">
                            Salvar
                        </button>
                    </div>
                </div>
            </form>
        </modal>

        <modal :show.sync="modals.modalCancelarAtividade">
            <loader object="#df3e46" v-show="progressAtividadeCancelar" color1="#0db9d3" color2="#fff01f" size="6" speed="2.4" bg="#C0C0C0" objectbg="#0d0c0d" opacity="50" name="circular"></loader>
            <form class="ml-3 mt-3 mr-3 mb-3">
                <h4 class="text-center">Cancelar Atividade</h4>
                <div class="row">

                    <div class="col">
                        <label for="inputTitulo">
                            Justificativa do cancelamento
                            <el-tooltip content="Campo obrigatório" placement="top">
                                <i style="font-size: 12px" class="fas fa-exclamation-circle text-info ml-1"></i>
                            </el-tooltip>
                        </label>
                        <div class="input-group">
                            <div class="input-group-prepend mb-2">
                                <span class="input-group-text"><i class="fas fa-align-left"></i></span>
                            </div>
                            <textarea rows="2" 
                                v-model="atividadeCancelar.justificativa"
                                class="form-control mb-2"
                                maxlength="200"
                                placeholder="Preencha a justificativa"></textarea>
                        </div>
                    </div>
                </div>
                <br class="clear" />
                <div class="row">
                    <div class="col text-center mt-3">
                        <button type="button" 
                                @click="fecharModalCancelarAtividade()"
                                class="btn btn-danger mr-3">
                            Desistir
                        </button>
                        <button type="button" 
                                @click="cancelarAtividade()"
                                class="btn btn-success ml-3">
                            Salvar
                        </button>
                    </div>
                </div>
            </form>
        </modal>

        <modal :show.sync="modals.modalHistoricoAtividade" size="lg">
            <loader object="#df3e46" v-show="progressAtividadeHistorico" color1="#0db9d3" color2="#fff01f" size="6" speed="2.4" bg="#C0C0C0" objectbg="#0d0c0d" opacity="50" name="circular"></loader>
            
            <h4 class="text-center">Histórico Atividade</h4>
            <div class="listaAtividade p-2 text-justify">

                <div class="mb-3 linhaSeparacao" v-for="historico in listaHistorico" :key="historico.idatividadehistorico">
                    <div class="mb-1 ml-2">
                        <i :class="historico.tipoIcone +` mr-1 icones font-13`"></i> <strong>{{ historico.titulo }}</strong> &nbsp; {{ historico.tempoDataHora }}<br/>
                        {{ historico.descricao }}
                    </div>
                    <div class="row mt-2 mb-1">
                        <div class="col-6">
                            <div class="row">
                                <div class="col-1">
                                    <img :src="historico.criador.avatar" :title="historico.criador.nome" width="27" class="rounded-circle ml-2 mr-2">
                                </div>
                                <div class="col ml-3 mt-1">
                                    {{ historico.criador.apelido }}
                                </div>
                            </div>
                        </div>
                        <div class="col-6 text-right font-13">
                            {{ historico.dataAlteracao }}
                        </div>
                    </div>
                </div>
            </div>
            <br class="clear" />
            <div class="row">
                <div class="col text-center mt-3">
                    <button type="button" 
                            @click="fecharModalHistoricoAtividade()"
                            class="btn btn-danger mr-3">
                        Fechar
                    </button>
                </div>
            </div>
        </modal>

        <modal :show.sync="modals.modalReagendarProjetoAtividade">
            <loader object="#df3e46" v-show="progressReagendarProjetoAtividade" color1="#0db9d3" color2="#fff01f" size="6" speed="2.4" bg="#C0C0C0" objectbg="#0d0c0d" opacity="50" name="circular"></loader>
            
            <h4 class="text-center">Reagendar Atividade Pendentes</h4>
            <div class="listaAtividade p-2 text-justify">

                <div class="mb-3 p-1 linhaSeparacao atividadeIndividual" v-for="atividade in listaReagendarProjetoAtividade" :key="atividade.idatividade">
                    <div class="text-bold-6" :class="'titulo-'+ atividade.situacao">
                        {{ atividade.codigoNome }}
                    </div>
                    <div class="row mt-1">
                        <div class="col-7">
                            <div class="text-bold-6">
                                Data Início e Fim 
                            </div>
                            <div class="row">
                                <div class="col-6">
                                    <flat-picker
                                        value=""
                                        tabindex="3"
                                        id="dataInicio"
                                        class="form-control datepicker mb-2"
                                        placeholder="Data Início"
                                        v-model="atividade.dataInicio"
                                        :config="{
                                            allowInput: true,
                                            dateFormat: 'd/m/Y',
                                        }"/>
                                </div>
                                <div class="col-6">
                                    <flat-picker
                                        value=""
                                        tabindex="3"
                                        id="dataFim"
                                        class="form-control datepicker mb-2 ml-n2"
                                        placeholder="Data Fim"
                                        v-model="atividade.dataFim"
                                        :config="{
                                            allowInput: true,
                                            minDate: atividade.dataInicio,
                                            dateFormat: 'd/m/Y',
                                        }"/>
                                </div>
                            </div>
                        </div>
                        <div class="col-5">
                            <div class="text-bold-6">
                                Situação
                            </div>
                            <div class="mt-1" :class="'situacao-'+ atividade.situacao">
                                {{atividade.situacaoDescricao}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br class="clear" />
            <div class="row">
                <div class="col text-center mt-3">
                    <button type="button" 
                            @click="fecharModalReagendarProjetoAtividade()"
                            class="btn btn-danger mr-3">
                        Desistir
                    </button>
                    <button type="button" 
                            @click="reagendarProjetoAtividade()"
                            class="btn btn-success ml-3">
                        Reagendar
                    </button>
                </div>
            </div>
        </modal>

        <modal id="modalAtividadeCadastro" :show.sync="modals.modalAtividadeCadastro" size="lg">
            <div class="text-right iconeFecharModalCadastro">
                <span @click="closeModalAtividadeCadastro()" class="pull-right clickable close-icon" data-effect="fadeOut"><i class="fa fa-times"></i></span>
            </div>
            <AtividadeFormulario v-if="modals.modalAtividadeCadastro" 
                @atualizar-lista="carregarListaAtividade" 
                @fechar-cadastro="closeModalAtividadeCadastro"
                :projetoSelecao=projetoModal 
                :atividadeSelecao=atividadeModal />
        </modal>

        <modal id="modalProjetoResponsavel" :show.sync="modals.modalProjetoResponsavel" size="md">
            <div class="text-right iconeFecharModalCadastro">
                <span @click="closeModalProjetoResposanvel()" class="pull-right clickable close-icon" data-effect="fadeOut"><i class="fa fa-times"></i></span>
            </div>
            <h4 class="text-center">Adicionar um responsável</h4>
            <div class="row">
                <div class="col input-group">
                    <div class="input-group-prepend mb-2">
                        <span class="input-group-text">
                            <i class="fas fa-search"></i>
                        </span>
                    </div>
                    <input type="text" class="form-control mb-2"
                        v-model="addRespNome"
                        placeholder="Pesquisar por nome"
                        @keyup="pesquisarResp()" />
                </div>
            </div>
            <div style="height: 200px; border: 1px dashed #c0c0c0; overflow: auto">
                <div class="listaGT" v-for="resp in listaAddResp" :key="resp.idusuario">
                    <div class="gtInfo" @click="adicionarResp(resp)">
                        {{ resp.nome }} ({{resp.apelido}})
                        <i class="fas fa-plus text-muted opcao mr-3"></i>
                    </div>
                </div>
            </div>
            <br class="clear" />
            <div class="col-md-12 text-center mt-3">
                <button type="button" class="btn btn-danger ml-4" @click="closeModalProjetoResposanvel">
                    Fechar
                </button>
            </div>
        </modal>

    </div>
</template>

<script>
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import AtividadeFormulario from "@/components/AtividadeFormulario.vue";

const cacheProjetoDados = {};

export default {
    name: 'Projeto',
    props: ['projetoSelecionado', 'carregandoExterno'],
	components: {
		flatPicker,
        AtividadeFormulario
	},
	created() {
        this.carregarResponsaveisPendentes();
		this.carregarListaAtividade();
	},
	watch: {
		projetoSelecionado(novoProjeto) {
			if (novoProjeto && novoProjeto.idprojeto) {
				this.projeto = Object.assign({
                    titulo: '',
                    criador: {},
                    listaResponsavel: [],
                    listaResponsavelPendente: [],
                }, novoProjeto);
                this.carregarResponsaveisPendentes();
				this.carregarListaAtividade();
			}
		}
	},
	data() {
        const projetoInicial = this.projetoSelecionado || {};
		return {
			perfilCoordenador: localStorage.getItem("pnome") == "COORDENADOR" || localStorage.getItem("pnome") == "ADMIN",
            projeto: Object.assign({
                titulo: '',
                criador: {},
                listaResponsavel: [],
                listaResponsavelPendente: [],
            }, projetoInicial),
			progressProjeto: false,
			progressProjetoCancelar: false,
			progressAtividadeCancelar: false,
			progressAtividadeHistorico: false,
            progressReagendarProjetoAtividade: false,
            projetoReagenda: {},
            atividadeReagenda: {},
            observacao: {},
			listaAtividade: [],
			listaAtividadeFiltro: [],
            listaTimeline: [],
            listaHistorico: [],
            listaReagendarProjetoAtividade: [],
            atividadeCancelar: {},
            projetoCancelar: {},
            sitFiltroAtividade: {
                NI: true,
                EA: true,
                AT: true,
                CO: true,
                CA: true,
            },
            modals: {
                modalReagendarProjeto: false,
                modalCancelarProjeto: false,
                modalReagendarAtividade: [],
                modalCancelarAtividade: false,
                modalHistoricoAtividade: false,
                modalReagendarProjetoAtividade: false,
                modalAtividadeCadastro: false,
                modalProjetoResponsavel: false,
            },
			projetoModal: null,
			atividadeModal: null,
            carregandoAtividades: true,
            carregandoTimeline: false,
            //relevanciaProjeto: "",
			listaAddResp: [],
			listaAddRespFiltro: [],
		};
	},
    computed: {
        investimentoProjetoFmt() {
            const listaBase = (Array.isArray(this.listaAtividadeFiltro) && this.listaAtividadeFiltro.length > 0)
                ? this.listaAtividadeFiltro
                : (Array.isArray(this.listaAtividade) ? this.listaAtividade : []);

            if (listaBase.length === 0) {
                return (this.projeto && this.projeto.investimentoFmt) ? this.projeto.investimentoFmt : 'R$ 0,00';
            }

            let total = 0;
            for (const atividade of listaBase) {
                total += this.parseMoedaNumero(atividade && atividade.investimento);
                total += this.parseMoedaNumero(atividade && atividade.investimentoNaoEmpenho);
            }

            return total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        }
	},
	methods: {
        carregarResponsaveisPendentes() {
            if (!this.projeto || !this.projeto.idprojeto) {
                this.projeto.listaResponsavelPendente = [];
                return;
            }

            const idProjeto = this.projeto.idprojeto;
            this.$clubApi.get("/projeto/responsavel/pendente/"+ idProjeto)
                .then((response) => {
                    if (this.projeto.idprojeto === idProjeto) {
                        this.projeto.listaResponsavelPendente = response.data.object || [];
                    }
                })
                .catch((error) => {
                    const msg = error.response && error.response.data
                        ? error.response.data.msg
                        : null;
                    this.$toastr.error(msg || "Erro ao carregar responsáveis pendentes.");
                });
        },
        parseMoedaNumero(valor) {
            if (valor === null || valor === undefined || valor === '') return 0;
            if (typeof valor === 'number') return Number.isNaN(valor) ? 0 : valor;

            const texto = String(valor).replace(/\s/g, '').replace(/\./g, '').replace(',', '.');
            const numero = Number(texto);
            return Number.isNaN(numero) ? 0 : numero;
        },
        getIconClass(relevancia) {
            // Define as classes de ícone com base na relevância
            return {
                'fa fa-angle-double-up text-danger': relevancia === "MUITOALTA",
                'fa fa-angle-up text-danger': relevancia === "ALTA",
                'fa fa-minus': relevancia === "MEDIA",
                'fa fa-angle-down text-success': relevancia === "BAIXA",
                'fa fa-angle-double-down text-success': relevancia === "MUITOBAIXA"
            };
        },
		carregarListaAtividade() {

            //this.relevanciaProjeto = "fa fa-angle-double-up";

            if (!this.projeto || !this.projeto.idprojeto) {
                this.carregandoAtividades = false;
                this.carregandoTimeline = false;
                this.progressProjeto = false;
                return;
            }

            const idProjeto = this.projeto.idprojeto;
            const cacheProjeto = cacheProjetoDados[idProjeto];
            if (cacheProjeto) {
                this.listaAtividade = cacheProjeto.listaAtividade || [];
                this.listaAtividadeFiltro = cacheProjeto.listaAtividadeFiltro || this.listaAtividade;
                this.listaTimeline = cacheProjeto.listaTimeline || [];
                this.selecionarFiltroTarefa();
                this.filtrarAtividade();
                this.carregandoAtividades = false;
                this.carregandoTimeline = false;
                this.progressProjeto = false;
                return;
            }

            this.progressProjeto = true;
            this.carregandoAtividades = true;
            this.carregandoTimeline = true;
            this.listaTimeline = [];

            this.$clubApi.get("/projeto/atividade/"+ this.projeto.idprojeto).then((response) => {
				// ATIVIDADE
                this.listaAtividade = response.data.object;
                for (let index = 0; index < this.listaAtividade.length; index++) {
                    this.modals.modalReagendarAtividade.splice(index, 1, false);
                }
                this.listaAtividadeFiltro = response.data.object;
                this.selecionarFiltroTarefa();
                this.filtrarAtividade();
                cacheProjetoDados[idProjeto] = {
                    listaAtividade: this.listaAtividade,
                    listaAtividadeFiltro: this.listaAtividadeFiltro,
                    listaTimeline: [],
                };

                // Finaliza loader principal ao concluir dados da primeira aba.
                this.carregandoAtividades = false;
                this.progressProjeto = false;

                // Timeline carrega em background sem bloquear a primeira aba.
                this.$clubApi.get("/projeto/timeline/"+ this.projeto.idprojeto)
                    .then((timelineResponse) => {
                        this.listaTimeline = timelineResponse.data.object || [];
                        cacheProjetoDados[idProjeto] = {
                            listaAtividade: this.listaAtividade,
                            listaAtividadeFiltro: this.listaAtividadeFiltro,
                            listaTimeline: this.listaTimeline,
                        };
                    })
                    .catch((timelineError) => {
                        const msg = timelineError.response.data.msg;
                        this.$toastr.error(msg || "Erro ao carregar timeline do projeto.");
                    })
                    .finally(() => {
                        this.carregandoTimeline = false;
                    });
			})
            .catch((error) => {
                this.$toastr.error(error.response.data.msg);
                this.carregandoTimeline = false;
            })
            .finally(() => {
                if (this.carregandoAtividades) {
                    this.carregandoAtividades = false;
                    this.progressProjeto = false;
                }
            });
        },
        selecionarFiltroTarefa() {
            if (this.situacaoProjeto('CANCELADO') || this.situacaoProjeto('CONCLUIDO')) {
                this.sitFiltroAtividade = {
                    NI: false,
                    EA: false,
                    AT: false,
                    CO: true,
                    CA: true,
                }
            }      
        },
        formatarData(dataDMY) {
            const dia = dataDMY.split("/")[0];
            const mes = dataDMY.split("/")[1];
            const ano = dataDMY.split("/")[2];
            return new Date(ano, mes - 1, dia);
        },

        // - PROJETO
        situacaoNaoCACOProjeto(projeto) {
            return !(projeto.situacao == 'CANCELADO' || projeto.situacao == 'CONCLUIDO');
        },
        situacaoProjeto(situacao) {
            return this.projeto.situacao == situacao;
        },
        incluirProjeto(){
            location.href = '/projeto-cadastro';
        },
        modalReagendarProjeto() {
            this.projetoReagenda = { ...this.projeto };
            this.modals.modalReagendarProjeto = true;
        },
        fecharModalReagendarProjeto() {
            this.projetoReagenda = {};
            this.modals.modalReagendarProjeto = false;
        },
        concluirProjeto(projeto) {
            if (this.carregandoAtividades) {
                this.$toastr.warning("Aguarde o carregamento das atividades para concluir o Projeto.");
                return;
            }

            this.progressProjeto = true;
            this.$clubApi.get("/projeto/atividade/"+ projeto.idprojeto).then((response) => {
                const listaAtividadeProjeto = response.data.object || [];
                const possuiAtividadeEmAberto = listaAtividadeProjeto.some((atividade) => {
                    return atividade.situacao != 'CONCLUIDA' && atividade.situacao != 'CANCELADA';
                });

                if (possuiAtividadeEmAberto) {
                    this.$toastr.warning("Não é permitido concluir o Projeto, pois existem atividades em aberto.");
                    return;
                }

                if (!confirm('Deseja realmente CONCLUIR o Projeto:\n- '+ 
                    projeto.codigoNome +'\n\nTodas as atividades e tarefas '+
                    ' relacionadas à esse projeto serão concluídas.')) {
                    return;
                }

                return this.$clubApi.post("/projeto/concluir", projeto).then(() => {
                    this.atualizarListagem();
                    this.fecharModalProjeto();
                    this.$toastr.success("Projeto concluído com sucesso!");
                });
            })
            .catch((error) => {
                this.$toastr.error(error.response.data.msg);
            })
            .finally(() => {
                this.progressProjeto = false;
            });
        },
        excluirProjeto(projeto) {
			if (confirm('Deseja realmente EXCLUIR o Projeto:\n- '+ 
                    projeto.codigoNome +'\n\nTodas as atividades e tarefas relacionadas à esse projeto serão excluídas.')) {
                this.progressProjeto = true;
                this.$clubApi.post("/projeto/excluir", projeto).then(() => {
                    this.atualizarListagem();
                    this.$toastr.success("Projeto excluído com sucesso!");
                    this.fecharModalProjeto();
                })
                .catch((error) => {
                    this.$toastr.error(error.response.data.msg);
                })
                .finally(() => {
                    this.progressProjeto = false;
                });
            }
        },
        reagendarProjeto() {
            this.progressProjeto = true;
            let projetoAux = {
                dataInicio: this.projetoReagenda.dataInicio,
                dataFim: this.projetoReagenda.dataFim,
                idprojeto: this.projeto.idprojeto
            }
            this.$clubApi.post("/projeto/validar/reagendar", projetoAux).then((validoReagendar) => {
            
                if (validoReagendar.data.object) {

                    this.$clubApi.post("/projeto/prereagendar", projetoAux).then((response) => {

                        let listaAtividade = response.data.object;

                        // verifica se tem atividade fora do novo periodo do projeto e apresenta pro usuario
                        if (listaAtividade.length > 0) {

                            this.$toastr.warning("Existem atividades que estão fora do período do projeto "+
                                " e precisam ser reagendadas!");

                            // mostra a lista de atividades pendentes de reagendamento
                            this.modals.modalReagendarProjetoAtividade = true;
                            this.listaReagendarProjetoAtividade = listaAtividade;

                            this.progressProjeto = false;
                        // se não tiver, reagenda o projeto normalmente
                        } else {
                            if (confirm('Deseja realmente REAGENDAR o Projeto?')) {

                                this.projeto.dataInicio = this.projetoReagenda.dataInicio;
                                this.projeto.dataFim = this.projetoReagenda.dataFim;

                                this.$clubApi.post("/projeto/reagendar", this.projeto).then(() => {
                                    this.carregarListaAtividade();
                                    this.atualizarListagem();
                                    this.fecharModalReagendarProjeto();
                                    this.$toastr.success("Projeto reagendado com sucesso!");
                                })
                                .catch((error) => {
                                    this.$toastr.error(error.response.data.msg);
                                })
                                .finally(() => {
                                    this.progressProjeto = false;
                                });
                            }
                        }
                    })
                    .catch((error) => {
                        this.$toastr.error(error.response.data.msg);
                    })
                    .finally(() => {
                        this.progressProjeto = false;
                    });

                } else {
                    this.$toastr.warning("Esse Projeto não pode ser reagendado, pois suas atividades não podem ser reagendadas!");
                }
            
            })
            .catch((error) => {
                this.$toastr.error(error.response.data.msg);
            })
            .finally(() => {
                this.progressProjeto = false;
            });
            
        },
        reagendarProjetoAtividade() {
            if (this.validarReagendarProjetoAtividade()) {
                if (confirm('Deseja realmente REAGENDAR o Projeto e a(s) Atividade(s)?')) {
                    this.progressReagendarProjetoAtividade = true;
                    let reagendarProjetoAtividade = {
                        projeto: this.projeto,
                        listaAtividade: this.listaReagendarProjetoAtividade
                    }
                    this.$clubApi.post("/projeto/atividade/reagendar", reagendarProjetoAtividade).then(() => {
                        this.carregarListaAtividade();
                        this.atualizarListagem();
                        this.fecharModalReagendarProjetoAtividade();
                        this.$toastr.success("Atividade(s) reagendada(s) com sucesso!");
                    })
                    .catch((error) => {
                        this.$toastr.error(error.response.data.msg);
                    })
                    .finally(() => {
                        this.progressReagendarProjetoAtividade = false;
                    });
                }
            } else {
                this.$toastr.error("Data da Atividade está fora do período do Projeto");
            }
        },
        validarReagendarProjetoAtividade() {
            for (let i = 0; i < this.listaReagendarProjetoAtividade.length; i++) {
                const atividade = this.listaReagendarProjetoAtividade[i];
                
                if (atividade.dataInicio == "" || atividade.dataFim == "") {
                    return false;
                }
                let menorInicio = this.formatarData(this.projetoReagenda.dataInicio) > this.formatarData(atividade.dataInicio);
                let maiorFim = this.formatarData(this.projetoReagenda.dataFim) < this.formatarData(atividade.dataFim);
                if (menorInicio || maiorFim) {
                    return false;
                }
            }
            return true;
        },
        fecharModalReagendarProjetoAtividade() {
            this.fecharModalReagendarProjeto();
            this.listaReagendarProjetoAtividade = [];
            this.modals.modalReagendarProjetoAtividade = false;
        },
        modalCancelarProjeto(projeto) {
            let projetoCancelar = {
                idprojeto: projeto.idprojeto
            }
            this.projetoCancelar = projetoCancelar;
            this.projetoCancelar.justificativa = null;
            this.modals.modalCancelarProjeto = true;
        },
        fecharModalCancelarProjeto() {
            this.modals.modalCancelarProjeto = false;
        },
        cancelarProjeto() {
            if (this.validaProjetoCancelar()) {
				if (confirm('Deseja realmente CANCELAR esse Projeto?\n\nTodas as atividades e tarefas relacionadas à esse projeto serão canceladas')) {
                    this.progressProjetoCancelar = true;
                    this.$clubApi.post("/projeto/cancelar", this.projetoCancelar).then(() => {
                        this.projetoCancelar = {};
                        this.modals.modalCancelarProjeto = false;
                        this.atualizarListagem();
                        this.fecharModalProjeto();
                        this.$toastr.success("Projeto cancelado com sucesso!");
                    })
                    .catch((error) => {
                        this.projetoCancelar = {};
                        this.modals.modalCancelarProjeto = false;
                        this.$toastr.error(error.response.data.msg);
                    })
                    .finally(() => {
                        this.progressProjetoCancelar = false;
                    });
                }
            }
        },
		validaProjetoCancelar() {
			var camposValidos = true;
			if (this.projetoCancelar.justificativa == null ||
                    this.projetoCancelar.justificativa.trim() == "") {
				this.$toastr.error("Justificativa do cancelamento do Projeto obrigatória!");
				camposValidos = false;
			}
			return camposValidos;
		},
        exibirOpcaoExcluirProjeto() {
            return (localStorage.getItem("pnome") === "ADMIN");
        },

        // - ATIVIDADE
        modalReagendarAtividade(index, atividade) {
            this.atividadeReagenda = { ...atividade };
            this.modals.modalReagendarAtividade.splice(index, 1, true);
        },
        fecharModalReagendarAtividade(index) {
            this.atividadeReagenda = {};
            this.modals.modalReagendarAtividade.splice(index, 1, false);
        },
        reagendarAtividade(index, atividade) {
			if (confirm('Deseja realmente REAGENDAR a Atividade?')) {
                
                atividade.dataInicio = this.atividadeReagenda.dataInicio;
                atividade.dataFim = this.atividadeReagenda.dataFim;

                this.progressProjeto = true;
                this.$clubApi.post("/atividade/reagendar", atividade).then(() => {
                    this.carregarListaAtividade();
                    this.fecharModalReagendarAtividade(index);
                    this.atualizarListagem();
                    this.$toastr.success("Atividade reagendada com sucesso!");
                })
                .catch((error) => {
                    this.$toastr.error(error.response.data.msg);
                })
                .finally(() => {
                    this.progressProjeto = false;
                });
            }
        },
        alterarAtividade(atividade) {
            location.href = '/atividade-cadastro/'+ atividade.idatividade;
        },
        alterarProjeto(projeto) {
            location.href = '/projeto-cadastro/'+ projeto.idprojeto;
        },
        incluirAtividade(){
            //location.href = '/atividade-cadastro/projeto/'+ this.projeto.idprojeto;
            this.abrirModalAtividadeCadastro(this.projeto, null);
        },
        modalHistoricoAtividade(atividade) {
            this.listaHistorico = [];
            this.progressAtividadeHistorico = true;
            this.$clubApi.get("/atividade/historico/"+ atividade.idatividade).then((response) => {
                this.listaHistorico = response.data.object;
            })
            .finally(() => {
                this.progressAtividadeHistorico = false;
            });
            this.modals.modalHistoricoAtividade = true;
        },
        fecharModalHistoricoAtividade() {
            this.listaHistorico = [];
            this.modals.modalHistoricoAtividade = false;
        },
        modalCancelarAtividade(atividade) {
            this.atividadeCancelar = atividade;
            this.atividadeCancelar.justificativa = null;
            this.modals.modalCancelarAtividade = true;
        },
        fecharModalCancelarAtividade() {
            this.modals.modalCancelarAtividade = false;
        },
        cancelarAtividade() {
            if (this.validaAtividadeCancelar()) {
				if (confirm('Deseja realmente CANCELAR essa Atividade?\n\nTodas as tarefas relacionadas à essa atividade serão canceladas')) {
                    this.progressAtividadeCancelar = true;
                    this.$clubApi.post("/atividade/cancelar", this.atividadeCancelar).then(() => {
                        //this.limparAtividade();
                        this.carregarListaAtividade();
                        this.atividadeCancelar.justificativa = null;
                        this.atividadeCancelar = {};
                        this.modals.modalCancelarAtividade = false;
                        this.atualizarListagem();
                        this.$toastr.success("Atividade cancelada com sucesso!");
                    })
                    .catch((error) => {
                        this.$toastr.error(error.response.data.msg);
                    })
                    .finally(() => {
                        this.progressAtividadeCancelar = false;
                    });
                }
            }
        },
		validaAtividadeCancelar() {
			var camposValidos = true;
			if (this.atividadeCancelar.justificativa == null ||
                    this.atividadeCancelar.justificativa.trim() == "") {
				this.$toastr.error("Justificativa do cancelamento da Atividade obrigatória!");
				camposValidos = false;
			}
			return camposValidos;
		},
        concluirAtividade(atividade) {
			if (confirm('Deseja realmente CONCLUIR a Atividade:\n- '+ 
                    atividade.codigoNome +'\n\nTodas as tarefas relacionadas à essa atividade serão concluídas.')) {
                this.progressProjeto = true;
                this.$clubApi.post("/atividade/concluir", atividade).then(() => {
                    this.carregarListaAtividade();
                    this.atualizarListagem();
                    this.$toastr.success("Atividade concluída com sucesso!");
                })
                .catch((error) => {
                    this.$toastr.error(error.response.data.msg);
                })
                .finally(() => {
                    this.progressProjeto = false;
                });
            }
        },
		abrirModalAtividadeCadastro(projeto, atividade) {
			this.projetoModal = projeto;
			this.atividadeModal = atividade;
			this.modals.modalAtividadeCadastro = true;
		},
		closeModalAtividadeCadastro() {
			this.modals.modalAtividadeCadastro = false;
		},
        atualizarListagem() {
            this.$emit('atualizar-lista', {});
        },
        abrirModalAdicionarResponsavel() {
			this.addRespNome = "";
			if (this.listaAddRespFiltro.length == 0) {
				this.listaAddResp = [];
				let objConsulta = {
					grupoTrabalho: this.projeto.listaGrupoTrabalho
				}	
				this.progress = true;
				this.$clubApi.post("/user/nome/", objConsulta).then((response) => {
					this.listaAddResp = response.data.object;
					this.listaAddRespFiltro = response.data.object;
				})
				.catch((error) => {
					this.$toastr.error(error.response.data.msg);
				})
				.finally(() => {
					this.progress = false;
				});
			} else {
				this.listaAddResp = this.listaAddRespFiltro;
			}
			this.modals.modalProjetoResponsavel = true;
        },
        removerResponsavel(resp) {
            let efetivos = this.projeto.listaResponsavel.filter(r => !r.pendente);
            if (!resp.pendente && efetivos.length <= 1) {
				this.$toastr.error("Projeto não pode ficar sem um responsável.");
                return;
            }
            if (confirm('Retirar do Projeto o responsável '+ resp.nome +'?')) {
                this.$clubApi.delete("/projeto/responsavel/"+ this.projeto.idprojeto +"/"+ resp.idusuario).then((response) => {
                    this.projeto.listaResponsavel = this.projeto.listaResponsavel.filter((r) => r.idusuario != resp.idusuario);
                    this.$toastr.success ("Responsável retirado!");
                })
                .catch((error) => {
                    this.$toastr.error(error.response.data.msg);
                })
                .finally(() => {
                    this.progress = false;
                });
            }
        },
		closeModalProjetoResposanvel() {
			this.modals.modalProjetoResponsavel = false;
		},
		pesquisarResp() {
            if (this.addRespNome == "") {
				this.listaAddResp = this.listaAddRespFiltro;
			} else {
				this.listaAddResp = this.listaAddRespFiltro.filter((usuario) => {
					return (usuario.nome.toUpperCase().indexOf(this.addRespNome.toUpperCase()) >= 0)
						|| (usuario.apelido.toUpperCase().indexOf(this.addRespNome.toUpperCase()) >= 0);
				});
			}
		},
		adicionarResp(respAdd) {
            const responsaveis = this.projeto.listaResponsavel || [];
            const pendentes = this.projeto.listaResponsavelPendente || [];
            const podeAdd = !responsaveis.concat(pendentes).some(
                (resp) => resp.idusuario === respAdd.idusuario
            );
			if (podeAdd) {
			    if (confirm('Incluir o responsável '+ respAdd.nome +'?\n\nEssa inclusão ainda precisa ser validada pelo usuário.')) {
                    this.$clubApi.post("/projeto/responsavel/"+ this.projeto.idprojeto +"/"+ respAdd.idusuario).then((response) => {
                        this.projeto.listaResponsavelPendente.push(respAdd);
                        this.closeModalProjetoResposanvel();
                        this.$toastr.success ("Responsável adicionado! O usuário "+ respAdd.nome +" ainda precisa aprovar a responsabilidade!");
                    })
                    .catch((error) => {
                        this.$toastr.error(error.response.data.msg);
                    })
                    .finally(() => {
                        this.progress = false;
                    });
                }
			} else {
				this.$toastr.error("Responsável já adicionado anteriormente.");
			}
		},
        situacaoNaoCACOAtividade(atividade) {
            return !(atividade.situacao == 'CANCELADA' || atividade.situacao == 'CONCLUIDA');
        },
        situacaoAbertoProjeto(projeto){
            return projeto.situacao === "NAOINICIADO" || projeto.situacao === "EMANDAMENTO"
                || projeto.situacao === "ATRASADO";
        },
        situacaoREJEITADOProjeto(projeto){
            return projeto.situacao === "REJEITADO";
        },
        situacaoVACACOREProjeto(projeto){
            return projeto.situacao === "VALIDANDO" || projeto.situacao === "CANCELADO" 
            || projeto.situacao === "CONCLUIDO" || projeto.situacao === "REJEITADO";
        },
        situacaoAtividade(atividade, situacao) {
            return atividade.situacao == situacao;
        },
        filtraAtividadeNI() {
            this.sitFiltroAtividade.NI = !this.sitFiltroAtividade.NI;
            this.filtrarAtividade();
        },
        filtraAtividadeEA() {
            this.sitFiltroAtividade.EA = !this.sitFiltroAtividade.EA;
            this.filtrarAtividade();
        },
        filtraAtividadeAT() {
            this.sitFiltroAtividade.AT = !this.sitFiltroAtividade.AT;
            this.filtrarAtividade();
        },
        filtraAtividadeCO() {
            this.sitFiltroAtividade.CO = !this.sitFiltroAtividade.CO;
            this.filtrarAtividade();
        },
        filtraAtividadeCA() {
            this.sitFiltroAtividade.CA = !this.sitFiltroAtividade.CA;
            this.filtrarAtividade();
        },
        filtrarAtividade() {
            this.listaAtividade = this.listaAtividadeFiltro.filter((atividade) => {
                return (
                    (this.sitFiltroAtividade.NI && atividade.situacaoSigla=="NI") ||
                    (this.sitFiltroAtividade.EA && atividade.situacaoSigla=="EA") ||
                    (this.sitFiltroAtividade.AT && atividade.situacaoSigla=="AT") ||
                    (this.sitFiltroAtividade.CO && atividade.situacaoSigla=="CO") ||
                    (this.sitFiltroAtividade.CA && atividade.situacaoSigla=="CA")
                );
            })
        },
		abrirModalAtividade(atividade) {
            this.$emit('fechar-projeto', {});
            this.$emit('abrir-atividade', atividade);
		},
		fecharModalProjeto() {
            this.$emit('fechar-projeto', {});
		},
    },
}
</script>
<style>
.clickable {
  cursor: pointer;
}
.clickable:hover {
  cursor: pointer;
  text-decoration: underline;
}
.text-bold-6 {
    font-weight: 600;
}
.font-14 {
    height: 450px;
    font-size: 14px;
}
.font-13 {
    font-size: 13px;
}
.menuOpcao {
    font-size: 14px;
    font-weight: 600;
    border-bottom: 1px dashed #808080;
}
.legenda {
    font-size: 15px;
    font-weight: 600;
    border-bottom: 1px dashed #C0C0C0;
}
.listaResponsavelProjeto {
    max-height: 90px;
    overflow-x: hidden;
    overflow-y: scroll;
    scrollbar-width: thin;          /* "auto" or "thin" */
}
.listaAtividade {
    height: 300px;
    overflow-x: hidden;
    overflow-y: scroll;
    scrollbar-width: thin;          /* "auto" or "thin" */
}
.atividadeIndividual:hover {
    background-color: #f0f0f0;
}
.icones {
    color: #0f0044;
    cursor: pointer;
    font-size: 17px;
}
.iconeCancelar:hover {
    color: red;
}
.iconeConcluir:hover {
    color: green;
}
.iconeAlterar:hover {
    color: #979700;
}
.iconeReagendar:hover {
    color: #0000ff;
}
.titulo-CANCELADA {
    text-decoration: line-through;
}
.titulo-CONCLUIDA {
    color: #28a745;
}
.titulo-ATRASADA {
    color: #dc3545;
}
.situacao-CANCELADO {
    font-weight: 600;
    color: #dc3545;
}
.situacao-CONCLUIDO {
    font-weight: 600;
    color: #28a745;
}
.situacao-ATRASADA {
    font-weight: 600;
    color: #dc3545;
}
.situacao-CANCELADA {
    font-weight: 600;
    color: #dc3545;
}
.situacao-CONCLUIDA {
    font-weight: 600;
    color: #28a745;
}
.situacao-ATRASADO {
    font-weight: 600;
    color: #dc3545;
}
.situacao-REJEITADO {
    font-weight: 600;
    color: #961824;
}
.linhaSeparacao {
    border-bottom: 1px dashed #808080;
}

/* TIMELINE */

.container-timeline {
    margin-left: 160px;
    height: 290px;
    overflow-x: hidden;
    overflow-y: scroll;
    scrollbar-width: thin;
}

.timeline-header {
    font-size: 14px;
}

.timeline {
    list-style: none;
    padding: 20px 0 0;
    position: relative;
}

.timeline:before {
    background-color: #eee;
    bottom: 0;
    content: " ";
    left: 50px;
    margin-left: -1.5px;
    position: absolute;
    top: 0;
    width: 3px;
}

.timeline-item {
    margin-bottom: 20px;
    position: relative;
}
.timeline-item:before {
    content: " ";
    display: table;
}
.timeline-item:after {
    clear: both;
}

.timeline-panel {
        border-radius: 3px;
        border: 1px solid #d4d4d4;
        box-shadow: 3px 3px 5px rgba(100, 100, 100, 0.2);
        margin-left: 100px;
        padding: 20px;
        position: relative;
        width: 500px;
}

.timeline-badge {
    background-color: #999;
    border-radius: 50%;
    color: #fff;
    font-size: 1.4em;
    height: 40px;
    left: 54px;
    line-height: 40px;
    margin-left: -25px;
    position: absolute;
    text-align: center;
    top: 14px;
    width: 40px;
    z-index: 100;
}

.timeline-badge:before {
    border-bottom: 15px solid transparent;
    border-left: 0 solid #ccc;
    border-right: 15px solid #ccc;
    border-top: 15px solid transparent;
    content: " ";
    display: inline-block;
    position: absolute;
    left: 57px;
    right: auto;
    top: 6px;
}
.timeline-badge:after {
    border-bottom: 14px solid transparent;
    border-left: 0 solid #fff;
    border-right: 14px solid #fff;
    border-top: 14px solid transparent;
    content: " ";
    display: inline-block;
    position: absolute;
    left: 58px;
    right: auto;
    top: 7px;
}

.timeline-title {
    margin-top: 0;
    color: inherit;
    font-size: 14px;
    font-weight: 600;
    border-bottom: 1px solid rgb(220, 225, 230);
}

.timeline-autor {
    margin-bottom: 0;
    margin-top: 5px;
    font-size: 13px;
}

.timeline-body {
    margin-bottom: 0;
    margin-top: 10px;
    font-size: 13px;
}

.timeline-tempoDataHora {
    margin-bottom: 0;
    margin-top: 5px;
    font-size: 13px;
    text-align: right;
    color: #999;
}

.projeto-criado {
    background-color: #b9b71a;
}
.projeto-alterado {
    background-color: #e4e294;
    color: #505524;
}
.projeto-situacao {
    background-color: #6e1d6a;
}
.projeto-concluido {
    background-color: #40fc50;
    color: #222222;
}
.projeto-aceite {
    background-color: #297429;
}
.projeto-negada {
    background-color: #bd3118;
}
.projeto-validado {
    background-color: #0b4e0b;
}
.projeto-cancelado {
    background-color: #8d1818;
}
.projeto-reagendado {
    background-color: #161fa0;
}
.projeto-rejeitado {
    background-color: #df0000;
}
.filtroTarefa {
    border: 1px solid #d8d8d8;
    border-radius: 10px;
    font-size: 10px;
    cursor: pointer;
}
.filtroTarefa:hover {
    border: 1px solid #525252;
    cursor: pointer;
}
.filtroNItrue {
    color: white;
    background-color: #808080;
}
.filtroNIfalse {
    color: #808080;
}
.filtroEAtrue {
    color: white;
    background-color: #17a2b8;
}
.filtroEAfalse {
    color: #17a2b8;
}
.filtroREtrue {
    color: white;
    background-color: #17a2b8;
}
.filtroREfalse {
    color: #17a2b8;
}
.filtroATtrue {
    color: white;
    background-color: #ff436cee;
}
.filtroATfalse {
    color: #ff436cee;
}
.filtroCAtrue {
    color: white;
    background-color: #ff436cee;
}
.filtroCAfalse {
    color: #ff436cee;
}
.filtroCOtrue {
    color: white;
    background-color: #42a842;
}
.filtroCOfalse {
    color: #42a842;
}
.font-reagenda {
    color: #b821bd;
    font-weight: 600;
}
.iconeFecharModalCadastro {
	position: absolute; 
	z-index: 1; 
	width: 95%; 
	color: darkred;
}
</style>
